__turbopack_context__.v({
  "ButtonContainer": "sidebar-module__kOsjDq__ButtonContainer",
  "Content": "sidebar-module__kOsjDq__Content",
  "Removed": "sidebar-module__kOsjDq__Removed",
  "Visible": "sidebar-module__kOsjDq__Visible",
  "fadeIn": "sidebar-module__kOsjDq__fadeIn",
  "fadeOut": "sidebar-module__kOsjDq__fadeOut",
});
